/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.detail.settings.controllers', [
  'acme.common.service.passes',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])

.controller('PassesDetailSettingsController', ['$scope', '$filter', 'CalendarService', 'PassesService', 'UserPreferencesService', function($scope, $filter, CalendarService, PassesService, UserPreferencesService) {

    $scope.passesDetailSettings = {

      model: {},
      startDate: new Date(),
      endDate: new Date(),
      visitCountType: 'single',
      dateFormat: UserPreferencesService.getDateFormat('month', 'dateFormat'),

      init: function() {
        this.model = PassesService.attributes.getModel();
        this.endDate = new Date(this.startDate.getFullYear() + 1, this.startDate.getMonth(), this.startDate.getDate());
        $scope.$on('PassesDetailController::UpdateModel', this.onPassesDetailControllerUpdateModel);
        $scope.$on('PassesDetailController::Save', this.onPassesDetailControllerSave);
        this.onPassesDetailControllerUpdateModel();
      },

      restoreDates: function() {
        this.endDate = $filter('date')(CalendarService.parseDate(this.model.endDate), this.dateFormat);
        this.startDate = $filter('date')(CalendarService.parseDate(this.model.startDate), this.dateFormat);
      },

      restoreMaxUses: function() {

        switch (this.model.maxUses) {
          case null:
            this.visitCountType = 'unlimited';
            break;
          case 1:
            this.visitCountType = 'single';
            break;
          case 0:
            /* falls through */
          default:
            this.visitCountType = 'count';
            break;
        }

      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPassesDetailControllerUpdateModel: function(e, data) {
        var self = $scope.passesDetailSettings;

        self.model = PassesService.attributes.getModel();
        self.restoreDates();
        self.restoreMaxUses();
      },

      onPassesDetailControllerSave: function(e, data) {
        var self = $scope.passesDetailSettings;

        PassesService.series.setModel(self.model.series);
      }

    };

    $scope.passesDetailSettings.init();

}]);